<template>
  <swiper-slide><slot /></swiper-slide>
</template>

<script>
export default {};
</script>
